export type UserIdentityLabel={firstName?:string|null;lastName?:string|null;email?:string|null;role?:string|null}

const clean=(value?:string|null)=>value?.trim()||''

export function userDisplayName(user:UserIdentityLabel){
 const name=[clean(user.firstName),clean(user.lastName)].filter(Boolean).join(' ')
 return name||clean(user.email)||'Unnamed CRM user'
}

export function userSelectorLabel(user:UserIdentityLabel){
 const name=userDisplayName(user),email=clean(user.email),role=clean(user.role)
 return [name,email&&email!==name?email:'',role].filter(Boolean).join(' · ')
}

export function userInitials(user:UserIdentityLabel){
 const name=[clean(user.firstName),clean(user.lastName)].filter(Boolean)
 if(name.length)return name.map(value=>value[0]).join('').slice(0,2).toUpperCase()
 const fallback=clean(user.email)||'U'
 return fallback[0].toUpperCase()
}
